import { getSurveyQuestionnaire } from "state/modules/survey/selectors";

export const getThankyouProps = state => {
  const questionniare = getSurveyQuestionnaire(state);
  if (!questionniare) {
    return {};
  }

  let score = state.survey.score;
  if (score === null) {
    score = 3;
  }

  const messageKey = {
    0: {
      text: "positive_thankyou_message",
      text_urdu: "positive_thankyou_message_urdu",
    },
    1: {
      text: "neutral_thankyou_message",
      text_urdu: "neutral_thankyou_message_urdu",
    },
    2: {
      text: "negative_thankyou_message",
      text_urdu: "negative_thankyou_message_urdu",
    },
    3: {
      text: "default_thankyou_message",
      text_urdu: "negative_thankyou_message_urdu",
    },
  };

  const imageKey = {
    0: "positive_thankyou_image",
    1: "neutral_thankyou_image",
    2: "negative_thankyou_image",
    3: "default_thankyou_image",
  };

  const name = state.customer.name || "";
  const { lang } = state.response;
  return {
    image: questionniare[imageKey[score]] || questionniare[imageKey[3]],
    message: questionniare[messageKey[score][lang]]?.replace("%s", name),
  };
};
